import React from 'react'
import { motion } from 'framer-motion'
import { FiMonitor, FiSun, FiMoon } from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'
import HelpTooltip from './HelpTooltip'
import { useAppearance } from '../contexts/AppearanceContext'
import { hapticSelection } from '../services/hapticsService'

const OPTIONS = [
  { value: 'system', label: 'System', icon: FiMonitor },
  { value: 'light', label: 'Light', icon: FiSun },
  { value: 'dark', label: 'Dark', icon: FiMoon },
]

const AppearanceSection = () => {
  const { appearance, setAppearance, reduceMotion, setReduceMotion } = useAppearance()

  return (
    <div>
      <h3 className="text-lg font-bold text-text-primary mb-5">Appearance</h3>

      <div className="grid grid-cols-3 gap-2 sm:gap-4">
        {OPTIONS.map(({ value, label, icon }) => {
          const active = appearance === value
          return (
            <motion.button
              key={value}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => { hapticSelection(); setAppearance(value); }}
              aria-pressed={active}
              aria-label={`Set theme to ${label}`}
              className={`p-3 sm:p-4 rounded-xl border-2 transition-all duration-200 text-left flex items-center justify-center min-h-[80px] sm:min-h-[100px] bg-card ${
                active ? 'border-accent' : 'border-border-subtle'
              }`}
            >
              <div className="flex flex-col sm:flex-row items-center w-full sm:items-center">
                <div
                  className={`w-8 h-8 sm:w-10 sm:h-10 rounded-xl flex items-center justify-center sm:mr-3 mb-1 sm:mb-0 flex-shrink-0 ${
                    active ? 'bg-accent' : 'bg-surface'
                  }`}
                >
                  <SafeIcon
                    icon={icon}
                    className={`w-4 h-4 sm:w-5 sm:h-5 ${active ? 'text-white' : 'text-text-muted'}`}
                  />
                </div>
                <div className="flex-1 text-center sm:text-left">
                  <h5
                    className={`text-sm sm:text-base font-bold whitespace-nowrap ${
                      active ? 'text-accent' : 'text-text-primary'
                    }`}
                  >
                    {label}
                  </h5>
                </div>
              </div>
            </motion.button>
          )
        })}
      </div>

      <button
        type="button"
        onClick={() => { hapticSelection(); setReduceMotion(!reduceMotion); }}
        aria-pressed={reduceMotion}
        className="mt-5 w-full px-4 py-3 rounded-xl border border-border-subtle bg-card flex items-center justify-between text-left transition-colors duration-200 hover:bg-surface"
      >
        <div>
          <div className="text-sm sm:text-base font-bold text-text-primary">Reduce motion</div>
          <div className="text-xs sm:text-sm text-text-muted mt-0.5">
            Disables transitions and animations across the app.
          </div>
        </div>
        <div
          className={`relative w-11 h-6 rounded-full transition-colors duration-200 flex-shrink-0 ml-4 ${
            reduceMotion ? 'bg-accent' : 'bg-border-subtle'
          }`}
        >
          <div
            className={`absolute top-0.5 left-0.5 w-5 h-5 bg-card rounded-full shadow transition-transform duration-200 ${
              reduceMotion ? 'translate-x-5' : ''
            }`}
          />
        </div>
      </button>
    </div>
  )
}

export default AppearanceSection
